import {
  Alert,
  AlertColor,
  Snackbar,
} from "@mui/material";
import React, { useEffect } from "react";
import {
  Button,
  Container,
  Content,
  ContentBody,
  ContentInput,
  ContentInputProfilePhoto,
  ContentInputProfilePhotoIcon,
  ContentTitle,
  Title,
} from "./styles";
import { useNavigate } from "react-router-dom";
import CustomSelection, {
  valueProp,
} from "../../../Components/CustomSelection";
import { UserPermissions } from "../../../App";

interface Props {
  userPermissions: UserPermissions;
}
const CreatePatients: React.FC<Props> = ({ userPermissions }) => {
  const navigate = useNavigate();

  const [software, setSoftware] = React.useState<{
    name: string;
    id: string;
    description: string;
  }>({
    name: "",
    id: "",
    description: " ",
  });
  const [owners, setOwners] = React.useState<valueProp>([
    /*{ label: "ResearchX", type: 'user', value: 'research_x', checked: false }*/
    //Layout
  ]);
  const [categories, setCategories] = React.useState<valueProp>([
    { label: "Balance", value: "Balance", checked: false },
    { label: "Cognition", value: "Cognition", checked: false },
    { label: "Upper Limb", value: "Upper Limb", checked: false },
    { label: "Mobility", value: "Mobility", checked: false },
    { label: "Fitness", value: "Fitness", checked: false },
  ]);

  const getPossibleOwnerList = () => {
    fetch("/api/v1/software/getCreationProperties", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.success === true) {
          console.log("Got possible owner list!");
          setOwners(
            data.possibleOwnerList.map((val: any) => {
              return {
                label: val.name,
                type: val.type,
                value: val.id,
                checked: false,
              };
            })
          );
        }
      }).catch((err) => {
        console.log("Cannot get possible owner list:", err);
      })
  };
  useEffect(() => {
    getPossibleOwnerList();
  }, []);

  const [logo, setLogo] = React.useState<string>("");
  const hiddenLogoInput = React.useRef<HTMLInputElement>(null);

  const onImageChangeClick = () => {
    if (hiddenLogoInput.current) {
      hiddenLogoInput.current.click();
    }
  };
  const onHiddenLogoInputChange = (event: any) => {
    const fileUploaded = event.target.files[0];

    var reader = new FileReader();
    var baseString;
    reader.onloadend = function () {
      baseString = reader.result;
      setLogo(baseString + "");
    };
    reader.readAsDataURL(fileUploaded);
  };

  const [showStatus, setShowStatus] = React.useState(false);
  const [statusMsg, setStatusMsg] = React.useState("");
  const [statusSeverity, setStatusSeverity] =
    React.useState<AlertColor>("error");
  const handleCloseStatus = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setShowStatus(false);
  };

  const onCreateSoftware = () => {
    const toSend = {
      ...software,
      logo,
      categories: categories
        .filter((category) => category.checked)
        .map((category) => {
          return category.value;
        }),
      owners: owners
        .filter((owner) => owner.checked)
        .map((owner) => {
          return {
            type: owner.type,
            id: owner.value,
          };
        }),
    };
    console.log(toSend);

    fetch("/api/v1/software/create", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(toSend),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.success === true) {
          console.log("Created!");
          setStatusMsg("Software was created! Redirecting in 5 seconds...");
          setStatusSeverity("success");
          setShowStatus(true);
          setTimeout(() => {
            navigate(process.env.PUBLIC_URL + "/Softwares");
          }, 5000);
        } else {
          console.log("Not created: ", data.reason);
          if (data.reason === "Unkown Error")
            setStatusMsg(
              `Software was not created due to an unkown error. Refresh the page and try again.`
            );
          else setStatusMsg(`Software was not created: ${data.reason + ""}`);
          setStatusSeverity("error");
          setShowStatus(true);
        }
      }).catch((err) => {
        console.log("Failed to create a software: ", err);
        setStatusMsg(
          `Software was not created due to an unkown error. Refresh the page and try again.`
        );
        setStatusSeverity("error");
        setShowStatus(true);

      })
  };

  return (
    <Container>
      <Title>
        Create Software{" "}
        <Button
          onClick={() => {
            onCreateSoftware();
          }}
        >
          Create
        </Button>
      </Title>

      <Content>
        <ContentTitle>
          {software.name} {software.name && software.id && `(${software.id})`}
        </ContentTitle>

        <ContentBody>
          <ContentInput
            label="Name"
            variant="standard"
            onChange={(ev) =>
              setSoftware({ ...software, name: ev.target.value })
            }
          />
          <br />

          <ContentInput
            label="Package ID"
            variant="standard"
            onChange={(ev) => setSoftware({ ...software, id: ev.target.value })}
          />
          <br />

          <ContentInput
            id="standard-multiline-static"
            label="Description"
            multiline
            rows={4}
            variant="standard"
            value={software.description}
            onChange={(ev) =>
              setSoftware({ ...software, description: ev.target.value })
            }
          />
          <br />

          <CustomSelection
            title="Categories"
            value={categories}
            setValue={setCategories}
          />
          <br />

          <span style={{ position: "absolute", bottom: "0px" }}>
            {/**<CustomSelection
                            title="Authorized users"
                            value={allowedUsers}
                            inputText="Type the username..."
                        />
                        <br />**/}
            <CustomSelection
              title="Owners"
              value={owners}
              setValue={setOwners}
            />
          </span>

          <ContentInputProfilePhoto onClick={onImageChangeClick}>
            <img src={logo} alt="Click here to upload the software logo" />
            <ContentInputProfilePhotoIcon />
            <input
              type="file"
              ref={hiddenLogoInput}
              onChange={onHiddenLogoInputChange}
              style={{ display: "none" }}
            />
          </ContentInputProfilePhoto>
        </ContentBody>
      </Content>
      {/*<div style={{ height: 500, width: '100%', paddingTop: "1rem" }}>

    </div>*/}
      <Snackbar
        open={showStatus}
        autoHideDuration={6000}
        onClose={handleCloseStatus}
      >
        <Alert
          onClose={handleCloseStatus}
          severity={statusSeverity}
          sx={{ width: "100%" }}
        >
          {statusMsg}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default CreatePatients;
